module.exports = __webpack_public_path__ + "img/logo_text.b9079861.png";